export default "__VITE_ASSET__fcb51d4f__"